$(document).on('click', '#resident-table tbody tr', function(e){
	if($(e.target).closest('tr.group').length != 0){
		return true;
	}
	if($(e.target).is('.trash') || (getResident != undefined && getResident.progress().status != 200) || $(this).hasClass('noFacesheet') || $(this).hasClass('facilityFacesheet') || $(this).attr('id') == undefined){
		return false;
	}
	var id = $(this).attr('id');
	if(mainGraphFilter == 'lengthofstay'){
		id = id.split('_');
		id = id[0];
	}
  var from = $('#from').datepicker('getDate');
  var to = $('#to').datepicker('getDate');

  if(monthDiff(from, to) <= 1){
    from.setMonth(from.getMonth() - 1);
  }
  var fromUNIX = from.getTime() / 1000;
  var toUNIX = to.getTime() / 1000;


	passData = {
		hmp_uid: id,
    from: fromUNIX,
    to: toUNIX
	}
	if(usr_assoc_id != ''){
		passData['usr_assoc_id'] = usr_assoc_id;
	}
  


	getResident = $.get('/analytics/facesheet', passData, function(html){
		var bottomButtons = '<div class="text-right" id="popup_buttons">';
				bottomButtons += '<button id="cancelButton" onclick="removePopUpAndOverlay(undefined, true, \'noscroll\')">Cancel</button> <button id="saveResident">UPDATE</button>';
		bottomButtons += '</div>';

		$('.defPop').stop().css({'opacity':0, 'left': 'auto', 'right': 'auto', 'display': 'none'});
		$('body').addClass('relative');
		popup(html, 'body', 'wide facesheet', true, '2.5%', bottomButtons, 'noscroll');

		var default_date_val = new Date();
		var indicator_events = [
								{
									"title": "RESIDENT RIGHTS - HYGIENE",
									"start": "2015-08-03 19:35:39",
									"backgroundColor": "green"
								}
							];
		var survey_events = [
								{
									"title": "DIGNITY",
									"start": "2015-08-02 19:35:39",
									"backgroundColor": "red"
								}
							];
		$('#indicatorCalendar').fullCalendar({
			header: {
				left: 'prev,next today',
				center: 'title',
				right: 'month,basicWeek,basicDay'
			},
			defaultDate: default_date_val,
			editable: false,
			events: indicator_events
		});

		$('#surveyCalendar').fullCalendar({
			header: {
				left: 'prev,next today',
				center: 'title',
				right: 'month,basicWeek,basicDay'
			},
			defaultDate: default_date_val,
			editable: false,
			events: survey_events
		});
		if(isTour){
			$('.overlay').remove();
			if($('#step-facesheet-2').length == 0){
				$('body').append('<div id="step-facesheet-2" class="single-step" data-tour="1" data-step="10"><span class="connectorarrow-lm"></span><p>Upload a resident\'s photo by dragging and dropping an image here or press the upload button</p><footer><a href="#" class="ptbutton demoFacesheet" onclick="removePopUpAndOverlay(undefined, true, \'noscroll\');" data-powertour-action="prev"><span data-icon="L" class="icon"></span></a><a href="#" class="ptbutton end">END</a><a href="#" class="ptbutton" data-powertour-action="next"><span data-icon="R" class="icon"></span></a> </footer></div><div id="step-facesheet-3" class="single-step" data-tour="1" data-step="11"><span class="connectorarrow-tm"></span><p>Edit a resident\'s personal information within these fields</p><footer><a href="#" class="ptbutton" data-powertour-action="prev"><span data-icon="L" class="icon"></span></a><a href="#" class="ptbutton end">END</a><a href="#" class="ptbutton" data-powertour-action="next"><span data-icon="R" class="icon"></span></a> </footer></div><div id="step-facesheet-4" class="single-step" data-tour="1" data-step="12"><span class="connectorarrow-bm"></span><p>Edit a resident\'s medical information within these fields</p><footer><a href="#" class="ptbutton" data-powertour-action="prev"><span data-icon="L" class="icon"></span></a><a href="#" class="ptbutton end">END</a><a href="#" class="ptbutton" data-powertour-action="next"><span data-icon="R" class="icon"></span></a> </footer></div>');
			}
			$('.pop_up.facesheet').css('height', '88%');
			$.powerTour('update', ["#step-facesheet-2", "#step-facesheet-3", "#step-facesheet-4"]);
			$.powerTour('navigation', ["goto", 10]);
		}
	}, 'html');
});